import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const StyledInfoCard = styled.div<{ theme: { token: GlobalToken }; $hasError?: boolean }>`
  flex: 1;
  width: 100%;
  min-width: 250px;
  height: 100%;
  border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
  .ep-info-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${({ theme: { token } }) => token.padding}px;
    border: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px
      ${({ theme: { token } }) => token.borderRadiusLG}px 0 0;
  }

  .ep-info-card-title-wrapper {
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginXS}px;
  }

  .ep-info-card-title {
    color: ${({ theme: { token } }) => token.colorText};
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .ep-info-card-edit-button {
    color: ${({ theme: { token } }) => token.colorPrimary};
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    cursor: pointer;

    &.ep-info-card-edit-button-disabled {
      color: ${({ theme: { token } }) => token.colorTextDisabled};
      cursor: not-allowed;
    }
  }

  .ep-icon-avatar {
    background-color: ${({ theme: { token } }) => token.colorPrimaryBg};
    color: ${({ theme: { token } }) => token.colorPrimary};
  }

  .ep-info-card-content {
    display: flex;
    flex-direction: column;
    gap: ${({ theme: { token } }) => token.paddingXXS}px;
    padding: ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.paddingXL}px;
    border: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    border-top: none;
    border-radius: 0 0 ${({ theme: { token } }) => token.borderRadiusLG}px
      ${({ theme: { token } }) => token.borderRadiusLG}px;
    height: 5.5rem;
    overflow: hidden;
  }

  .ep-info-card-help {
    color: ${({ theme: { token } }) => token.colorError};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    margin-top: ${({ theme: { token } }) => token.marginXXS}px;
  }
`;
